export const setPermission = data => {
  return {
    type: 'SET_PERMISSION',
    data: data
  }
}